<template>
  <el-dialog append-to-body :title="$t('export_employee_info')" :visible.sync="visible" :close-on-click-modal="false">
    <section>
      <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">{{
        $t('21')
      }}</el-checkbox>
      <div style="margin: 15px 0"></div>
      <el-checkbox-group v-model="checkedItems" @change="handleCheckedCitiesChange">
        <el-checkbox v-for="item in allItems" :label="item[0]" :key="item[0]">{{ item[1] }}</el-checkbox>
      </el-checkbox-group>
    </section>
    <!-- 确认取消 -->
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('66') }}</el-button>
      <el-button type="primary" :disabled="this.checkedItems.length === 0" @click="download">{{ $t('68') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getExportColumns } from 'api/org/per'
export default {
  props: {},
  data() {
    return {
      visible: false,
      checkAll: false,
      checkedItems: [],
      allItems: [],
      isIndeterminate: true
    }
  },
  methods: {
    init() {
      this.visible = true
      this.checkedItems = []
      this.allItems = []
      this.isIndeterminate = true
      this.checkAll = false
      this.getField()
    },
    getField() {
      getExportColumns().then(data => {
        if (data.code === 1 && data.data instanceof Array) this.allItems = data.data
      })
    },
    handleCheckAllChange(val) {
      this.checkedItems = val ? this.allItems.map(i => i[0]) : []
      this.isIndeterminate = false
    },
    handleCheckedCitiesChange(value) {
      const checkedCount = value.length
      this.checkAll = checkedCount === this.allItems.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.allItems.length
    },
    download() {
      this.$emit('operate', this.checkedItems.join(','))
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog {
  max-width: 900px;
}
/deep/ .el-checkbox-group {
  .el-checkbox {
    width: 180px;
    .el-checkbox__label {
      vertical-align: top;
      white-space: break-spaces;
      word-break: break-word;
    }
    .el-checkbox__input {
      vertical-align: top;
    }
  }
  .el-checkbox:last-of-type {
    margin-right: 30px;
  }
}
</style>
